import React from "react"
export function QatarFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Qatar"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__qatar" fillRule="nonzero">
          <path
            id="prefix__Rectangle"
            stroke="#CCC"
            strokeWidth={0.5}
            fill="#FFF"
            d="M.25.25h23.5v15.5H.25z"
          />
          <path
            id="prefix__Path"
            fill="#751A46"
            d="M24 0v16H8.1l1.7-.805-2.3-1.208 2.3-1.207-2.3-1.208 2.3-1.207-2.3-1.208L9.8 8.05 7.5 6.843l2.3-1.208-2.3-1.207L9.8 3.22 7.5 2.013 9.8.906 8.1 0z"
          />
        </g>
      </g>
    </svg>
  )
}
